import React, { useCallback, useEffect } from 'react';
import { AnalyticsEventLocation } from '@mb/lib';
import * as Styled from './AskProductOrderDetails.styles';
import { IProduct } from '../../types';
import { getUniqueProducts } from '../../utils/getUniqueProducts';
import {
  AnalyticsEventAPQAction,
  AnalyticsEventName,
  sendAnalyticsEvent,
} from '../../utils/helpers/analytics';
import { AskProductOrderDetailsItem } from '../AskProductOrderDetailsItem';
import { AskProductOrderDetailsMore } from '../AskProductOrderDetailsMore';

interface AskProductOrderDetailsProps {
  isOrderDetailsOpen: boolean;
  products?: IProduct[];
}

export const AskProductOrderDetails: React.FC<AskProductOrderDetailsProps> = ({
  isOrderDetailsOpen,
  products,
}) => {
  const [showMore, setShowMore] = React.useState(false);
  useEffect(() => {
    if (!isOrderDetailsOpen) {
      setShowMore(false);
    }
  }, [isOrderDetailsOpen]);

  const handleShowMoreClick = useCallback(() => {
    setShowMore(true);
    sendAnalyticsEvent({
      event: AnalyticsEventName.APQ,
      event_location: AnalyticsEventLocation.HOME,
      action: AnalyticsEventAPQAction.SEE_MORE_BRAND_SAMPLES,
    });
  }, []);

  if (!products) return null;
  const uniqueProducts = getUniqueProducts(products);
  const limit: number = 9;
  const isMoreThanLimit = uniqueProducts.length > limit;
  const limitedMaterials = uniqueProducts.slice(0, limit);
  const excessMaterials = uniqueProducts.slice(limit);

  const renderProductList = (productList: IProduct[]) =>
    productList.map((product, index) => (
      <AskProductOrderDetailsItem
        key={index}
        product={product}
        compact={false}
      />
    ));

  return (
    <Styled.AskProductOrderDetailsWrapper
      isOrderDetailsOpen={isOrderDetailsOpen}
      compact={false}
    >
      {renderProductList(limitedMaterials)}
      {isMoreThanLimit && !showMore && (
        <AskProductOrderDetailsMore
          numberOfElements={uniqueProducts.length - limit}
          onClick={handleShowMoreClick}
        />
      )}
      {isMoreThanLimit && showMore && renderProductList(excessMaterials)}
    </Styled.AskProductOrderDetailsWrapper>
  );
};
